<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <dropdown
                :value="font"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import { generateClass } from '@/utils/tailwind-helper';

export default {
    name: 'calendar-facet-day-font-family',
    mixins: [baseOption],

    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            displayName: 'Font Family',
            tailwindDefinitionProp: 'fontFamily',
            font: '',
        };
    },

    computed: {
        options() {
            return this.themeObjectValues.map(v => ({ value: v, text: v }));
        },
    },

    methods: {
        onInput(valueNew) {
            let flexClassNew = '';
            if (valueNew) {
                flexClassNew = generateClass({
                    screen: this.screen,
                    tailwindDefinitionProp: this.tailwindDefinitionProp,
                    value: valueNew,
                });
            }

            this.onOptionChange(flexClassNew);
            this.$emit('input', flexClassNew);
        },

        onSelectedElement() {
            let { value } = this.value;

            if (!value) {
                value = this.getComputedValue();

                if (value.includes(',')) {
                    value = value.slice(0, value.indexOf(','));
                }
            }

            if (this.themeObjectValues.includes(value)) {
                this.font = value;
            } else {
                this.font = '';
            }
        },
    },
};
</script>
